import React from "react";
import PropTypes from "prop-types";
import { Modal, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons";

const euros = (cents) => `${((cents || 0) / 100).toFixed(2).replace(".", ",")} €`;

/**
 * Contenu de la commande, par-dessus la fenêtre SAV : l'agent vérifie ce qui a été
 * commandé sans ouvrir d'onglet ni perdre sa saisie.
 *
 * La fiche est servie par l'API, pas intégrée depuis le BO Symfony : le BO React
 * tourne sur un autre port, son cookie de session ne suit pas dans un cadre, et la
 * page réclamait une reconnexion. Le lien vers la fiche de production complète
 * reste disponible pour qui en a besoin.
 */
const OrderSheetModal = (props) => {
  const { show, onHide, orderId, order } = props;

  const url = orderId
    ? `${process.env.REACT_APP_LEMOULIN_BO_URL}/e28XmZh3/commande-production/${orderId}/show`
    : null;

  return (
    <Modal show={show} onHide={onHide} size="lg" scrollable>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: 20 }}>
          Commande {order?.numberOrder || ""}
        </Modal.Title>
        {url && (
          <a href={url} target="_blank" rel="noopener noreferrer" className="ml-auto mr-3 align-self-center small">
            <FontAwesomeIcon icon={faExternalLinkAlt} /> fiche de production complète
          </a>
        )}
      </Modal.Header>
      <Modal.Body>
        {!order ? (
          <p className="text-muted mb-0">Contenu de la commande indisponible.</p>
        ) : (
          <>
            <div className="mb-3" style={{ fontSize: "0.92rem" }}>
              {order.customer && (
                <div>
                  <b>{order.customer.name}</b>
                  {order.customer.email ? ` · ${order.customer.email}` : ""}
                  {order.customer.phone ? ` · ${order.customer.phone}` : ""}
                </div>
              )}
              <div className="text-muted">
                {order.orderedAt ? `Commandée le ${order.orderedAt}` : null}
                {order.deliveryDate ? ` · livraison le ${order.deliveryDate}` : ""}
                {order.timeSlot ? ` ${order.timeSlot}` : ""}
                {order.spot ? ` · ${order.spot}` : ""}
              </div>
            </div>

            <table className="table table-sm mb-2">
              <tbody>
                {(order.lines || []).map((line, idx) => (
                  <tr key={idx}>
                    <td style={{ width: 40 }} className="text-muted">
                      {line.menu ? "" : `${line.quantity} ×`}
                    </td>
                    <td>
                      {line.menu ? <span className="text-muted">↳ </span> : null}
                      {line.name}
                      {line.menu && <span className="text-muted"> — dans {line.menu}</span>}
                      {(line.ingredients || []).length > 0 && (
                        <div className="text-muted" style={{ fontSize: "0.82rem" }}>
                          {line.ingredients.join(", ")}
                        </div>
                      )}
                    </td>
                    <td className="text-right" style={{ width: 90, fontVariantNumeric: "tabular-nums" }}>
                      {line.price === null || line.price === undefined ? "" : euros(line.price)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <div className="d-flex justify-content-between" style={{ fontVariantNumeric: "tabular-nums" }}>
              <span className="text-muted">Total payé</span>
              <b>{euros(order.totalTTC)}</b>
            </div>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={onHide}>Fermer</Button>
      </Modal.Footer>
    </Modal>
  );
};

OrderSheetModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  orderId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  order: PropTypes.object,
};

export default OrderSheetModal;
